import React from 'react'
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap'
import DocumentList from './documentList'

import styles from './documents.module.scss'

const DocumentsSection = () => (
  <div id="documents" className="section light">
    <Container>
      <Row>
        <Col>
          <h2>Dokumenty</h2>
        </Col>
      </Row>
      <Row className={styles.section}>
        <Col sm="12" md="6" className={styles.wrapper}>
          <Card>
            <CardBody>
              <CardTitle>Zápisnice</CardTitle>
              <DocumentList category="reports" />
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Row>
            <Col sm="12" className={styles.wrapper}>
              <Card>
                <CardBody>
                  <CardTitle>Metodiky</CardTitle>
                  <DocumentList category="methodics" />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="12" className={styles.wrapper}>
              <Card>
                <CardBody>
                  <CardTitle>Dokumentácie</CardTitle>
                  <DocumentList category="documentation" />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </div>
)

export default DocumentsSection
